import * as yup from 'yup'

export const indexSchema = yup.object({
  index: yup.string().required('Index name is required'),
  body: yup.object().shape({
    properties: yup
      .string()
      .test('is-valid-mappings', 'Invalid mappings format', (value, context) => {
        if (!value) return context.createError({ message: 'Mappings are required' })
        try {
          const parsedValue = JSON.parse(value)
          return mappingsSchema.isValidSync(parsedValue)
        } catch (error) {
          return false
        }
      })
      .required('Mappings are required'),
  }),
})

const mappingsSchema = yup
  .object()
  .test(
    'properties-format',
    'Properties must be an object with string keys and objects containing type property',
    (value) => {
      if (!value || typeof value !== 'object') return false
      return Object.values(value).every(
        (prop) =>
          prop && typeof prop === 'object' && 'type' in prop && typeof prop.type === 'string',
      )
    },
  )

export const backendResourcesSchema = yup.object({
  id: yup.string().required('ID is required'),
  created: yup.string().required('Creation date is required'),
  updated: yup.string().required('Update date is required'),
  workflowStatus: yup.string().required('Workflow status is required'),
  workflowId: yup.string().required('Workflow ID is required'),
  stage: yup.string().required('Stage is required'),
  name: yup.string().required('Name is required'),
  description: yup.string().required('Description is required'),
  bucketArtifactsName: yup.string().required('Bucket artifacts name is required'),
  lambdaReader: yup.object().shape({
    srcKey: yup.string().required('Lambda reader source key is required'),
    memorySize: yup.number().required('Lambda reader memory size is required'),
    timeoutSeconds: yup.number().required('Lambda reader timeout seconds is required'),
  }),
  lambdaWriter: yup.object().shape({
    srcKey: yup.string().required('Lambda writer source key is required'),
    memorySize: yup.number().required('Lambda writer memory size is required'),
    timeoutSeconds: yup.number().required('Lambda writer timeout seconds is required'),
  }),
  events: yup.object().shape({
    source: yup.string().required('Event source is required'),
    detailType: yup.string().required('Event detail type is required'),
    externalAccountId: yup.string().required('Event external account ID is required'),
  }),
  domain: yup.object().shape({
    name: yup.string().required('Domain name is required'),
    enableCustomDomain: yup.boolean().required('Enable custom domain is required'),
  }),
  opensearch: yup.object().shape({
    instanceType: yup.string().required('OpenSearch instance type is required'),
    dataNodes: yup.number().required('OpenSearch data nodes is required'),
    volumeSize: yup.number().required('OpenSearch volume size is required'),
  }),
  tracking: yup.object().shape({
    enabled: yup.boolean().required('Tracking enabled is required'),
  }),
  outputs: yup.string().required('Outputs are required'),
})
